import { getInitialState as getNewsletterInitialState } from '../../global-store/subjects/newsletter';
import { getSiteName } from '../../utils/aem-utils';

/**
 * Map newsletter subscription coming from the service
 * @param {Object} data
 * @returns {Object}
 */
export function parseDataNewsletter(data) {
  if (!data) {
    return getNewsletterInitialState();
  }
  return data[getSiteName()];
}

/**
 * Map WPN options coming from the HTML into options for select box
 * @param {object} preferences
 * @param {boolean} isActive
 * @returns
 */
export const parseWPNOptionsForSelectBox = (options, selectedOptions) => {
  const isOptionActive = (option) => selectedOptions?.includes(option.value);

  return options.map((option) => ({
    ...option,
    modifiers: option.image ? ['radio', 'has-image'] : ['radio'],
    text: option.label,
    isActive: isOptionActive(option),
  }));
};

/**
 * Map images from the Sky Preferences Blocks for panels
 * @param {Array} images
 * @returns {Array}
 */
export const parseImagesForPanels = (images = []) =>
  images.map((image) => ({
    imgSrc: image.tablet,
    alt: image.alt,
    description: image.description,
    mobileSrcSet: `${image.mobile} 1x, ${image.mobile2x} 2x`,
    tabletSrcSet: `${image.tablet} 1x, ${image.tablet2x} 2x`,
  }));
